import { Menu } from '../interfaces/menu.interface';

export const MENU_OPTIONS = (
    isRouteActive: (menu: Menu) => boolean,
    callbackAction: (menu: Menu) => void
): Menu[] => {
    return [
        {
            title: 'Cambio',
            routePath: '/home/cambio',
            isRouteActive: (row: Menu) => isRouteActive ? isRouteActive(row) : false,
            callbackAction: (row: Menu) => callbackAction(row)
        },
        {
            title: 'Cuentas',
            routePath: '/home/cuentas',
            isRouteActive: (row: Menu) => isRouteActive ? isRouteActive(row) : false,
            callbackAction: (row: Menu) => callbackAction(row)
        },
        {
            title: 'Tarjetas',
            routePath: '/home/tarjetas',
            isRouteActive: (row: Menu) => isRouteActive ? isRouteActive(row) : false,
            callbackAction: (row: Menu) => callbackAction(row)
        },
        {
            title: 'Operaciones',
            routePath: '/home/operaciones',
            isRouteActive: (row: Menu) => isRouteActive ? isRouteActive(row) : false,
            callbackAction: (row: Menu) => callbackAction(row)
        }
    ];
};
